import { render, staticRenderFns } from "./ClassNPS.vue?vue&type=template&id=52f1d899&"
import script from "./ClassNPS.vue?vue&type=script&lang=ts&"
export * from "./ClassNPS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports